// extracted by mini-css-extract-plugin
module.exports = {"prefix":"maderas-camacho","primaryColor":"#b5191c","quaternaryColor":"#fff","secondaryColor":"#fcb140","tertiaryColor":"#000","quinaryColor":"#dcddde"};